
import { Context } from '@nuxt/types'
import { mapGetters } from 'vuex'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'

export default MachinationsLightPage.extend({
  name: 'Disclaimer',
  layout: 'base',
  computed: {
    ...mapGetters({
      disclaimer: 'wp/getDisclaimer',
      title: 'wp/getPageTitle',
    }),
  },
  async asyncData(context: Context): Promise<void> {
    const { store } = context
    await store.dispatch('common/setupPageLight', { context })
    await store.dispatch('wp/fetchDisclaimer', { context, commitPage: true })
  },
})
